import { useState } from "react";
import { Contact } from "../components/Contact";
import { FadeIn } from "../components/FadeIn";
import { ChevronDown, HelpCircle } from "lucide-react";

const FAQS = [
  {
    question: "What are the operating hours of G69 Spa Gurugram?",
    answer:
      "We are open 7 days a week from 10:00 AM to 11:00 PM. Late evening slots are available with prior booking.",
  },
  {
    question: "Do I need to book an appointment in advance?",
    answer:
      "While walk-ins are welcome depending on availability, prior booking via Call or WhatsApp is highly recommended to reserve your preferred therapist and time slot.",
  },
  {
    question: "Where is G69 Spa located in Gurgaon?",
    answer:
      "We are located at DLF Phase 1, Gurugram — right near Sikanderpur Metro Station and easily accessible from DLF Cyber City and Golf Course Road.",
  },
  {
    question: "Is complete privacy and discretion guaranteed?",
    answer:
      "Yes, 100%. Our branch features soundproof private therapy suites with attached showers, ensuring maximum privacy and confidentiality for every guest.",
  },
  {
    question: "What facilities are included in the 90-minute packages?",
    answer:
      "All 90-minute spa packages (Service Yellow & Service Rainbow) include full access to Steam & Sauna, Dark Room sensory lounge, and Lounge Bar refreshments.",
  },
  {
    question: "Do you offer doorstep spa services across Gurgaon?",
    answer:
      "Yes! We provide discreet doorstep male spa services at luxury hotels, residences, and apartments anywhere in Gurugram.",
  },
];

export const ContactPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="py-12 sm:py-20 px-4 sm:px-8 lg:px-12">
      {/* Banner */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-extrabold mb-3">
            Connect With Gurugram Branch
          </div>
          <h1 className="text-4xl sm:text-6xl font-serif font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-600 mb-6">
            Contact G69 Spa Gurgaon
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Have questions or want to reserve a session? Reach out to our Gurugram branch desk via Call or WhatsApp.
          </p>
        </FadeIn>
      </div>

      <Contact />

      {/* FAQs Section */}
      <div className="max-w-5xl mx-auto mt-16 sm:mt-24 pt-12 border-t border-white/10">
        <FadeIn className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-amber-400 font-bold mb-3 bg-amber-400/10 px-4 py-1.5 rounded-full border border-amber-400/20">
            <HelpCircle className="w-4 h-4" /> Got Questions?
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl font-black text-white tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-white/60 text-sm max-w-xl mx-auto mt-2">
            Find quick answers to common queries regarding our branch location, privacy standards, and booking procedures.
          </p>
        </FadeIn>

        <div className="space-y-4">
          {FAQS.map((faq, index) => {
            const isOpen = openFaq === index;
            return (
              <FadeIn key={index} delay={index * 0.05}>
                <div className="rounded-2xl border border-white/10 bg-[#0c0c0c] overflow-hidden transition-all duration-300 hover:border-amber-400/40">
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full text-left p-5 sm:p-6 flex justify-between items-center gap-4 text-white font-medium text-base sm:text-lg focus:outline-none"
                  >
                    <span className="font-serif font-bold text-amber-100">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-amber-400 shrink-0 transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 sm:px-6 pb-6 text-sm text-white/70 leading-relaxed border-t border-white/5 pt-4">
                      {faq.answer}
                    </div>
                  )}
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </div>
  );
};
